export default __webpack_public_path__ + "static/media/640_business03-jp-mobile.44fd0c5f.png";